export default "__VITE_ASSET__459b1c41__"